export const colors = {
    shadowLight:'rgba(0, 0, 0, 0.1)',
    black: '#000000',
    white: '#ffffff',
    primaryColor: '#343434',
    secondaryColor: '#102051',
    darkBlue:'#0D0B5B',
    purple: '#1B1464',
    goldColor: "#d6b827",
    blueColor: "#5dade2",
};

export const fontFamily = {
    primary:  `'Noto Sans', sans-serif`,
    secondary: `'Lato', sans-serif`,
}
export const DEFAULT_BUTTON_COLOR = '#4196CB';
